<template>
  <div id="app">
    <router-view v-if="isReloadAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      screenWidth: this.screenWidth
    };
  },
  data() {
    return {
      once: true,
      isReloadAlive: true,
      screenWidth: { value: document.body.clientWidth },
      timer: false
    };
  },
  created() {
    // console.log(this);
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign({}, JSON.parse(sessionStorage.getItem("store")))
      );
      sessionStorage.removeItem("store");
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    this.$store.dispatch("user/initUser");
    this.$store.dispatch("cart/initShoppingCart");
    this.$store.dispatch("user/setAllAddress");
    window.onresize = () => {
      return (() => {
        this.screenWidth.value = document.body.clientWidth;
      })();
    };
    if (this.screenWidth.value < 1024) {
      this.$message("Use PC for the best browsing experience");
    }
  },
  methods: {
    init() {},
    reload() {
      this.isReloadAlive = false;
      this.$nextTick(function() {
        this.isReloadAlive = true;
      });
    }
  },
  watch: {
    screenWidth(val) {
      // if (!this.timer) {
      this.screenWidth = val;
      console.log(this.screenWidth);
      // this.timer = true;
      // let that = this;
      // setTimeout(function() {
      //   that.timer = false;
      // }, 400);
      // }
    }
  }
};
</script>

<style>
@import url("style/index.scss");

#app {
  width: 100%;
  height: 100%;
  background-color: #f4f5f5;
  font-family: "Segoe UI";
  color: #fff;
}
a {
  color: #091d44;
}
*::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
*::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: #091d44;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}
*::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
.el-message-box-mobile {
  width: 300px !important;
}
.ban-on-selected {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
}
.can_click:hover {
  cursor: pointer;
  text-decoration: underline;
}
.checked_font {
  text-shadow: 0 0 3px #236f83;
  font-size: larger;
}
</style>



// WEBPACK FOOTER //
// src/App.vue